import { BackgroundData } from 'builder/components/WidgetConfigurations/Background/Background';
import { PaddingData } from 'builder/components/WidgetConfigurations/Padding';
import { ReactNode } from 'react';
import { BaseConfig } from 'shared/widgets/shared/types';

export const BELOW_HEADER_PLACEMENT = 'Below Header (Inline)';
export const STICKY_BOTTOM_PLACEMENT = 'Sticky Bottom (Fixed to Screen)';

export type BannerPlacement =
  | typeof BELOW_HEADER_PLACEMENT
  | typeof STICKY_BOTTOM_PLACEMENT;

export interface Config extends BaseConfig {
  width: number;
  height: number;
  minWidth: number;
  minHeight: number;
  xLocation: number;
  yLocation: number;
  uniqueId: string;
  borderData: BorderData;
  children?: ReactNode;
  backgroundData: BackgroundData;
  backgroundImage: Image;
  lineColor: string;
  paddingData: PaddingData;
  browserCondition: boolean;
  showonAllPage: boolean;
  browserList: string;
  dateSelection?: DateSelection;
  enableFullScreen: boolean;
  placement?: BannerPlacement;
  allowDismiss?: boolean;
}

export interface DateSelection {
  startDate: Date;
  endDate: Date;
  key: string;
}
